<template>
<div class="chapter">
<div class="inner_page">
<a id="page_2"></a>
<p class="ded"><span class="bold">To my wife, Florence, for her constant support and belief.</span></p>
<div class="img_container">
<img alt="image" src="images/f003-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?7976662d